import Vue from 'vue'
import Vuex from 'vuex'
import chatsModule from './modules/chats'
import packagesModule from './modules/packages'
import loginModule from './modules/login'
import emergenciesModule from './modules/emergencies'
import mobile from './modules/mobile'
import profile from './modules/profile'


Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    chats: chatsModule,
    packages: packagesModule,
    login: loginModule,
    emergencies: emergenciesModule,
    mobile: mobile,
    profile: profile
  }
})

export default store
